import enTranslations from '../messageTemplateCard/i18n/en.json';
import ptTranslations from '../messageTemplateCard/i18n/pt.json';
import esTranslations from '../messageTemplateCard/i18n/es.json';
/**
 * Shared language mapping constants for OTP authentication templates
 * Used across CreateMessageTemplateSidebarController and MessageTemplateCardController
*/
export const I18N_LANGUAGES = ['pt', 'en', 'es'];
export const LANGUAGE_VARIANTS = {
    pt: ['pt_BR', 'pt_PT'],
    en: ['en', 'en_US', 'en_GB'],
    es: ['es', 'es_ES', 'es_AR', 'es_MX'],
};
// Generate language map dynamically from variants
export const LANGUAGE_MAP = Object.entries(LANGUAGE_VARIANTS).reduce((map, [i18nLang, variants]) => {
    variants.forEach(variant => {
        map[variant] = i18nLang;
    });
    return map;
}, {});
export const TRANSLATIONS_MAP = {
    en: enTranslations,
    pt: ptTranslations,
    es: esTranslations,
};
export function getI18nLanguage(language) {
    return LANGUAGE_MAP[language];
}
// Gets the OTP button text for a given language, or undefined if not supported.
export function getOtpButtonText(language) {
    const i18nLanguage = LANGUAGE_MAP[language];
    if (!i18nLanguage) {
        return undefined;
    }
    const translations = TRANSLATIONS_MAP[i18nLanguage];
    return translations?.messageTemplateCard?.copyButton;
}
// Gets the authentication message text for a language, with an optional fallback to English.
export function getAuthenticationMessageText(language, fallbackToEnglish = true) {
    const i18nLanguage = LANGUAGE_MAP[language] || language.split('_')[0] || 'en';
    const translations = TRANSLATIONS_MAP[i18nLanguage] || (fallbackToEnglish ? TRANSLATIONS_MAP['en'] : undefined);
    if (!translations) {
        return fallbackToEnglish ? enTranslations.messageTemplateCard.authenticationMessage : '';
    }
    return translations.messageTemplateCard?.authenticationMessage || enTranslations.messageTemplateCard.authenticationMessage;
}
// Gets authentication texts (button and message) for a language, with an optional English fallback.
export function getAuthenticationTexts(language, fallbackToEnglish = true) {
    const i18nLanguage = LANGUAGE_MAP[language] || language.split('_')[0] || 'en';
    const translations = TRANSLATIONS_MAP[i18nLanguage] || (fallbackToEnglish ? TRANSLATIONS_MAP['en'] : undefined);
    if (!translations) {
        return {
            buttonText: fallbackToEnglish ? enTranslations.messageTemplateCard.copyButton : '',
            messageText: fallbackToEnglish ? enTranslations.messageTemplateCard.authenticationMessage : '',
        };
    }
    return {
        buttonText: translations.messageTemplateCard?.copyButton || enTranslations.messageTemplateCard.copyButton,
        messageText: translations.messageTemplateCard?.authenticationMessage || enTranslations.messageTemplateCard.authenticationMessage,
    };
}
// Checks if a language is explicitly supported for OTP templates.
export function isLanguageSupported(language) {
    return language in LANGUAGE_MAP;
}
